import {
    TimeFilter,
    TimeSpan,
} from '@shared/timeFilter/types';
import { startOfHour } from '@superbet-group/web.lib.utilities';

const eventLoadedByDateCache = new Set<string>();

export function isInCache(timeSpan?: TimeSpan, timeFilter?: TimeFilter, sportId?: number): boolean {
    const cacheKey = getCacheKey(timeSpan, timeFilter, sportId);
    const allSportsCacheKey = getCacheKey(timeSpan, timeFilter);
    const allTimesCacheKey = getCacheKey(timeSpan, TimeFilter.All, sportId);

    if (cacheKey == null || allSportsCacheKey == null || allTimesCacheKey == null) {
        return false;
    }

    return eventLoadedByDateCache.has(cacheKey)
        || eventLoadedByDateCache.has(allSportsCacheKey)
        || eventLoadedByDateCache.has(allTimesCacheKey);
}

export function markAsCached(timeSpan?: TimeSpan, timeFilter?: TimeFilter, sportId?: number): void {
    const cacheKey = getCacheKey(timeSpan, timeFilter, sportId);

    if (cacheKey != null) {
        eventLoadedByDateCache.add(cacheKey);
    }
}

export function purgeEventsByDateCache(): void {
    eventLoadedByDateCache.clear();
}

function getCacheKey(timeSpan?: TimeSpan, timeFilter?: TimeFilter, sportId?: number): string | null {
    if (timeSpan == null || timeFilter == null) {
        return null;
    }

    // Cache by the hour, this should be good enough
    const startDate = startOfHour(timeSpan.startDate).toISOString();
    const endDate = startOfHour(timeSpan.endDate).toISOString();
    const dateKey = `${startDate}-${endDate}`;
    // The time filter should be reduntant in some cases,
    // but it's better to go wide here and be sure we've loaded
    // the correct live offer in edge cases.
    // TODO: Check and clean up later
    const timeFilterKey = `${timeFilter}`;
    const sportKey = sportId != null ? `${sportId}` : 'all-sports';

    return timeFilter === TimeFilter.All
        ? `time-all-${sportKey}`
        : `${dateKey}-${timeFilterKey}-${sportKey}`;
}
